/* eslint-disable no-tabs */
import { GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  getWarehouses({ commit }) {
    commit('toggleLoading', true);

    return GraphQlClient.query(
      `
			query {
				warehouses {
					id
          official_name
          code
          federal_tax_payer_id
				}
			}
		`,
    )
      .then((res) => {
        const { data = {} } = res || {};
        const { warehouses = [] } = data || {};
        commit('setWarehouses', warehouses);
        commit('toggleLoading', false);
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./src/stores/warehouses/actions.js